// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ImgResponsive":"bby_a bhs_a bhs_q bhs_j bhs_wl bhs_bj","ImgResponsive__img":"bby_b bhs_b bhs_ql"};